import { createSelector } from '@reduxjs/toolkit';

export const selectLoggedUser = createSelector(
  (state) => state.auth,
  (auth) => auth.user
);
